import React, { useState, useEffect } from "react";
import {
  DevNote,
  FormFieldSet,
  InfoCardNew,
  InfoCardNewAdv,
  InfoWrapper,
  NewTabPill,
  CustomMonthPicker,
} from "../../../../components";
import ItModule from "./IncentiveModule/ItModule";
import NonItModule from "./IncentiveModule/NonItModule";
import BenchModule from "./IncentiveModule/BenchModule";
import { fetchIncentiveSummary } from "../../../../redux/slices/incentives/incentivesApi";
import dayjs from "dayjs";

const IncentiveModule = () => {

  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [summaryData, setSummaryData] = useState({ it: 0, nonit: 0, bench: 0, total: 0 });

  useEffect(() => {
    const loadSummary = async () => {
      try {
        const res = await fetchIncentiveSummary({
          month: dayjs(selectedMonth).month() + 1,
          year: dayjs(selectedMonth).year(),
        });
        setSummaryData(res);
      } catch (error) {
        console.error("Failed to fetch incentive summary:", error);
      }
    };
    loadSummary();
  }, [selectedMonth]);

  const IncentiveMenus = React.useMemo(
    () => [
      {
        title: "IT",
        page: <ItModule />,
        type: "main",
      },
      {
        title: "Non-IT",
        page: <NonItModule />,
        type: "main",
      },
      {
        title: "Benchsale",
        page: <BenchModule />,
        type: "main",
      },
    ],
    [],
  );

  const incentiveInfo = [
    { title: "IT", value: summaryData.it },
    { title: "Non-IT", value: summaryData.nonit },
    { title: "Benchsale", value: summaryData.bench },
    { title: "Total", value: summaryData.total },
  ];

  return (
    <div className="w-full flex flex-col gap-2">
      <DevNote>
        <div>
          Infocard data is currently dummy, so a loader is not implemented. Add
          Loader when real data is available.
        </div>
      </DevNote>
      <div className="w-full flex justify-end mt-1">
        <div className="w-full max-w-[200px]">
          <CustomMonthPicker
            selected={selectedMonth}
            onChange={(date) => setSelectedMonth(date)}
            size="sm"
          />
        </div>
      </div>

      <div className="bg-[#FAFCFF] flex flex-col px-3 py-4 border border-gray-200 rounded-2xl shadow-lg mt-1">
        <InfoWrapper className="!grid-cols-4 gap-4">
          {incentiveInfo.map((item, index) => (
            <InfoCardNewAdv
              key={index}
              title={item.title}
              value={item.value}
              prefix="$"
              valueConfig={{ decimals: 2 }}
              backValue={item.backValue}
              bgConfig={{ className: "rounded-xl border border-gray-100" }}
              layout="option9"
            />
          ))}
        </InfoWrapper>
      </div>
      

      <div className="flex">
        <NewTabPill
          tabs={IncentiveMenus}
          color="black"
          variant="outlined"
          mode="url"
          tabId="incentive-management"
        />
      </div>
    </div>
  );
};

export default IncentiveModule;
